
export const dispatchEvent = (element: Document|Window|HTMLElement, name: string, detail: any = {}): void => {
  const evt = new CustomEvent(name, {
    detail: detail,
  })

  element.dispatchEvent(evt)
}
